function elasticOut(t) {
  return Math.sin(-13.0 * (t + 1.0) * Math.PI/2) * Math.pow(2.0, -10.0 * t) + 1.0
}

module.exports = elasticOut


//////////////////
// WEBPACK FOOTER
// ./node_modules/eases/elastic-out.js
// module id = 39
// module chunks = 0 1